import React from 'react';
import { useSelector } from 'react-redux';

import '../../../../../../../../styles.css';

const QuickButtons = ({ onQuickButtonClicked }) => {
  const buttons = useSelector((state) => state.quickButtons.quickButtons);

  const getComponentToRender = (button) => {
    const ComponentToRender = button.component;
    return (
      <ComponentToRender
        onQuickButtonClicked={onQuickButtonClicked}
        button={button}
        key={`${button.label}-${button.id}`} // Ensure each key is unique
      />
    );
  };

  if (!buttons.length) return null;

  return (
    <div className="quick-buttons-container">
      <ul className="quick-buttons">
        {buttons.map((button) => (
          <li className="quick-list-button" key={`${button.label}-${button.id}`}>
            {getComponentToRender(button)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuickButtons;
